<app-dialog
  [title]="dialogData ? 'Edit Vendor' : 'New Vendor'"
  [actions]="[
    { text: 'Cancel', buttonStyle: 'underline' },
    { text: 'Save', isDisabled: !form.valid || spin, spin: spin }
  ]"
  (action)="action($event)"
  (close)="action()"
>
  <div class="vendor" [formGroup]="form">
    <div class="input-container">
      <label for="" class="input-container_label">Name<span class="input-container_asterisk">*</span></label>
      <input type="text" class="input-container_input" formControlName="name" />
      <div class="input-container_error-message" *ngIf="form.controls['name'].errors?.unique">
        Vendor name already exists
      </div>
    </div>

    <div class="input-container">
      <label for="" class="input-container_label">Address</label>
      <input
        type="text"
        class="input-container_input"
        formControlName="address1"
        #addressText
      />
    </div>

    <div class="input-container">
      <label for="" class="input-container_label">Phone</label>
      <input
        type="text"
        class="input-container_input"
        formControlName="phone"
        appPhoneMask
      />
    </div>

    <div class="input-container">
      <label for="" class="input-container_label">Email</label>
      <input
        type="text"
        class="input-container_input"
        formControlName="email"
      />
    </div>
    <app-page-container-devider
      [title]="'Vendor Settings'"
      [small]="true"
    ></app-page-container-devider>
    <div class="input-container">
      <label for="" class="input-container_label">Lead Days <span class="input-tooltip" [matTooltip]="'The estimated days it takes from placing an order till receiving it'"><i class="fas fa-info-circle"></i></span> </label>
      <input
        type="number"
        class="input-container_input"
        formControlName="leadDays"
        min="0"
      />
    </div>

    <div class="input-container">
      <label for="" class="input-container_label">Purchase Days <span class="input-tooltip" [matTooltip]="'The number of days to purchase to meet sales demand'"><i class="fas fa-info-circle"></i></span> </label>
      <input
        type="number"
        class="input-container_input"
        formControlName="purchaseDays"
        min="0"
      />
    </div>

    <div class="input-container">
      <label for="" class="input-container_label">Safety Stock <span class="input-tooltip" [matTooltip]="'The additional days of stock to store for safety reasons'"><i class="fas fa-info-circle"></i></span> </label>
      <input
        type="number"
        class="input-container_input"
        formControlName="safetyStock"
        min="0"
      />
    </div>
    <div class="input-container">
      <label for="" class="input-container_label">Minimum Order Value</label>
      <div class="input-container_wrapper">
        <input type="number" class="input-container_input input-container_input--number" formControlName="OrderMinimumAmount" min="0" />
        <span class="input-container_icon"> <i class="fa fa-dollar-sign"></i>
        </span>
      </div>
    </div>
    <div class="input-container">
      <label for="" class="input-container_label">Terms</label>
      <input
        type="text"
        class="input-container_input"
        formControlName="terms"
      />
    </div>
  </div>
</app-dialog>
